<template>
  <div class="alarm-information">
    <div class="box1">
      <div class="box1-message">
        <img :src="alarmInfo.portrait" alt="" class="box1-left" />
        <div class="box1-right">
          <p>
            <label for="">用户</label><label for="">:</label
            ><span>{{ alarmInfo.realName }}</span>
          </p>
          <p>
            <label for="">身份证号</label><label for="">:</label
            ><span>{{ alarmInfo.idCard }}</span>
          </p>
          <p>
            <label for="">电话</label><label>:</label><span>{{ alarmInfo.phone }}</span>
            <span
              style="margin-left: 30px; color: #236bed; cursor: pointer"
              @click="showMerc()"
              >紧急联系人</span
            >
          </p>
        </div>
      </div>

      <div class="box1-message1">
        <p>
          <label for="">报警时间:</label><span>{{ alarmInfo.happenDate }}</span>
        </p>
        <p>
          <label for="">报警地点:</label><span>{{ alarmInfo.address }}</span>
        </p>
        <p>
          <label for="">报警源:</label><span>{{ alarmInfo.alarmSourceName }}</span>
        </p>
        <p v-if="alarmInfo.typeName == '图文报警'">
          <label for="">报警类型:</label
          ><span @click="showDetails = true" style="cursor: pointer">{{
            alarmInfo.typeName
          }}</span>
        </p>
        <p v-else>
          <label for="">报警类型:</label><span>{{ alarmInfo.typeName }}</span>
        </p>
      </div>
    </div>
    <div class="box2">
      <div class="menu">
        <button
          @click="bntClick(i.id)"
          :class="{ selected: handleType === i.id }"
          v-for="i in box2Menu"
          :key="i.id"
        >
          {{ i.text }}
        </button>
      </div>
      <div class="deal-trouble">
        <edit-form
          v-if="handleType !== '5'"
          :button-config="buttonConfig"
          :form-config="formConfig"
          :rule-form="ruleForm"
          :rules="rules"
        ></edit-form>
        <div class="add-task" v-else>
          <Table :table-config="tableConfig" :templateData="tableData"></Table>
          <div class="table-bottom" @click="openDialog">添加任务</div>
        </div>
      </div>
    </div>

    <el-dialog
      title="添加出警人员任务"
      :before-close="beforeClose"
      :visible.sync="dialogShow"
      width="30%"
    >
      <div class="table_add">
        <Table
          :table-config="tableConfig1"
          :templateData="tableData1"
          :tabelButtons="tabelButtons"
        ></Table>
        <div style="display: flex; align-items: center">
          <el-form ref="taskform" :model="ruleForm" :rules="rules" style="width: 100%">
            <el-form-item label="紧急程度" prop="alarmGrade">
              <el-select v-model="ruleForm.alarmGrade" placeholder="请选择">
                <el-option
                  v-for="item in this.formConfig.items[0][0].data"
                  :key="item.value"
                  :label="item.itemName"
                  :value="item.itemValue"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <textarea
          v-model="ruleForm.content"
          style="
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            font-size: 14px;
            outline: none;
          "
          placeholder="请添加任务描述"
          name=""
          id=""
          cols="30"
          rows="5"
        ></textarea>
        <p slot="footer" class="dialog-footer">
          <el-button @click="dialogShow = false">取 消</el-button>
          <el-button type="primary" @click="addTask('taskform')">确 定</el-button>
        </p>
      </div>
    </el-dialog>

    <!-- 紧急联系人 -->
    <el-dialog title="紧急联系人" :visible.sync="merceDialog" :before-close="merceClose">
      <Table :table-config="tableConfig5" :templateData="tableData5"></Table>
    </el-dialog>
    <el-dialog
      title="修改"
      :visible.sync="editDialog"
      :before-close="beforeClose"
      width="30%"
    >
      <textarea
        :disabled="!canEdit"
        v-model="ruleForm.content"
        style="
          width: 100%;
          padding: 10px;
          box-sizing: border-box;
          font-size: 14px;
          outline: none;
        "
        placeholder="请添加任务描述"
        name=""
        cols="30"
        rows="5"
      >
      </textarea>
      <p slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button :disabled="!canEdit" type="primary" @click="editTask()"
          >确 定</el-button
        >
      </p>
    </el-dialog>

    <!-- 图文报警弹窗 -->
    <el-dialog
      :visible.sync="showDetails"
      width="500px"
      :before-close="closeDetails"
      title="图文报警详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <!-- <AlarmDetailBox :alarm-detail-data="alarmInfo"></AlarmDetailBox> -->
      <div class="clus">
        <span>时间：</span>
        <span>{{ alarmInfo.happenDate }}</span>
      </div>
      <div class="clus">
        <span>地点：</span>
        <span>{{ alarmInfo.address }}</span>
      </div>
      <div class="clus">
        <span>描述：</span>
        <span>{{ alarmInfo.content }}</span>
      </div>
      <info
        bgColor="rgb(242, 242, 242)"
        :file="alarmInfo.files"
        :content="alarmInfo.content"
      />
    </el-dialog>
  </div>
</template>

<script>
import { listAPI, mapAPI } from "@/api-path/command-center.js";
import publicAPI from "@/api-path/public-api.js";
import Info from "../help-info.vue";
export default {
  name: "alarm-infomation",
  props: ["alarmInfo"],
  components: {
    Info,
  },
  data() {
    return {
      canEdit: false, //是否可以编辑
      showDetails: false, //显示图文报警详情
      dialogShow: false,
      editDialog: false,

      box2Menu: [
        {
          id: "6",
          text: "线索",
        },
        {
          id: "7",
          text: "上报",
        },
        {
          id: "3",
          text: "误报",
        },
        {
          id: "2",
          text: "完成",
        },
        {
          id: "5",
          text: "处置",
        },
      ],
      handleType: "6",
      /*---------------表单---------------*/
      formConfig: {
        labelWidth: "80px",
        itemWidth: "100%",
        items: [
          [
            {
              show: false,
              label: "紧急程度",
              valueType: "select",
              prop: "alarmGrade",
              key: "alarmGrade",
              options: {
                label: "itemName",
                value: "itemValue",
              },
              data: [],
              // path: publicAPI.codeAndItem + '?codeValue=DEGREE_OF_EMERGENCY'
            },
          ],
          [
            {
              label: "描述",
              valueType: "textarea",
              rows: 4,
              prop: "content",
              key: "content",
            },
          ],
          [
            {
              label: "文件上传",
              valueType: "upload",
              key: "fileDTOList",
              otherConfig: {
                imgWidth: "120px",
                imgHeight: "100px",
                method: ["delete", "edit"],
              },
              uploadConfig: {
                accept: "image/jpeg, video/mp4, image/png,image/jpg",
                count: 1,
                size: "1024kb",
              },
              options: {
                fileUrlKey: "url",
              },
            },
          ],
        ],
      },
      buttonConfig: {
        position: "80px",
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: this.saveData,
          },
        ],
      },
      ruleForm: {
        content: "",
        alarmGrade: "",
        policemanIds: [],
        fileDTOList: [],
      },
      rules: {
        alarmGrade: [
          {
            required: true,
            message: "请选择紧急程度",
            trigger: "blur",
          },
        ],
      },

      /*---------------处置列表-------------*/
      tableConfig: {
        height: 500,
        rows: [
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "联系电话",
            prop: "phone",
          },
          {
            label: "任务",
            prop: "taskName",
          },
          {
            label: "状态",
            prop: "status",
          },
        ],
        rowButtons: {
          type: "plain",
          items: [
            {
              icon: "el-icon-edit",
              fn: this.openEditDialog,
            },
            {
              icon: "el-icon-delete",
              fn: this.deleteTask,
            },
          ],
        },
      },
      tableData: [],

      tabelButtons: [
        {
          type: "refresh",
          title: "刷新",
          fn: () => {
            // this.getUserTask()
            this.searchUser();
          },
        },
      ],
      /*--------------弹窗列表------------------*/
      tableConfig1: {
        checkbox: true,
        checkboxFn: (data) => {
          this.selectData = data;
        },
        rows: [
          {
            label: "姓名",
            prop: "realName",
          },
          {
            label: "联系电话",
            prop: "phone",
          },
          {
            label: "距离（米）",
            prop: "meter",
          },
        ],
      },
      tableData1: [],
      selectData: [],
      selectDisabeld: false,
      /*--------------紧急联系人-----------*/
      tableConfig5: {
        // height: 300,
        // checkbox: true,
        rows: [
          {
            label: "姓名",
            prop: "realName",
          },
          {
            label: "关系",
            prop: "relation",
          },
          {
            label: "电话",
            prop: "phone",
          },
        ],
      },
      tableData5: [],
      merceDialog: false,
    };
  },
  computed: {
    alarmId() {
      return this.$store.state.alarmId; //新的报警
    },
  },
  watch: {
    newAlarm(newVal, oldVal) {
      if (newVal) {
        console.log(newVal);
        this.search();
      }
    },
  },

  created() {
    // this.alarmId = this.$store.state.alarmId;
    this.getCode();
    // this.getAlarmDetail()
  },
  methods: {
    closeDetails() {
      this.showDetails = false;
    },
    /*-------------紧急联系人-----------*/
    merceClose() {
      this.merceDialog = false;
    },
    showMerc() {
      this.$http
        .get(listAPI.merce, {
          params: {
            alarmId: this.alarmId,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.merceDialog = true;
            this.tableData5 = res.result;
          }
        });
    },
    /* ------------------ 处置 （列表）------------------------*/

    // 查询列表
    getUserTask() {
      this.$http
        .get(`${mapAPI.officerTaskUserList}?alarmId=${this.alarmId}`)
        .then((res) => {
          if (res.status === 200) {
            res.result.map((item) => {
              item.status = this.matchFn.matchCodeName(
                "POLICE_TASK_STATE",
                item.status.toString()
              );
            });
            this.tableData = res.result;
          }
        });
    },

    // 列表删除
    deleteTask(data) {
      this.$confirm("此操作将永久删除该人员任务, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(mapAPI.deleteOfficerTask + "?taskId=" + data.taskId)
            .then((res) => {
              if (res.status === 200) {
                this.$message.success("删除成功");
                this.getUserTask();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 保存修改
    editTask() {
      let params = {
        content: this.ruleForm.content,
        id: this.ruleForm.id,
      };

      this.$http.post(mapAPI.updateOfficerTask, params).then((res) => {
        if (res.status === 200) {
          this.$message.success("修改成功");
          this.editDialog = false;
          this.$router.push("/command/up-report");
          // this.getUserTask()
        }
      });
    },

    // 打开修改弹窗
    openEditDialog(data) {
      if (data.status == "处理中") {
        this.canEdit = false;
      } else {
        this.canEdit = true;
      }
      this.ruleForm.content = data.taskName;
      this.ruleForm.id = data.taskId;
      this.editDialog = true;
    },

    /* -----------------处置（添加任务） ----------------*/
    // 打开添加人员弹窗
    openDialog() {
      this.searchUser();
      this.dialogShow = true;
    },

    // 查询出警员
    searchUser() {
      this.selectData = [];
      let params = {
        alarmId: this.alarmId,
        isUp: false,
      };
      this.$http
        .get(mapAPI.getPoliceUser, {
          params,
        })
        .then((res) => {
          if (res.status === 200) {
            let result = res.result["当日已签到出警员"];
            result.map((item) => {
              if(item.meter!=null && item.meter!='0' ){
                item.meter = parseInt(item.meter);
              }else{
                item.meter='无';
              }
            });
            this.tableData1 = res.result["当日已签到出警员"];
          }
        });
    },

    // 分派任务
    addTask(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            alarmId: this.alarmId,
            policemanIds: [],
            fileDTOList: [],
            handleType: 5,
            alarmGrade: this.ruleForm.alarmGrade,
            content: this.ruleForm.content,
          };
          this.selectData.forEach((item) => {
            params.policemanIds.push(item.id);
          });
          this.$http.post(mapAPI.addClues, params).then((res) => {
            if (res.status === 200) {
              this.$message.success("添加人员任务成功");
              this.getUserTask();
              this.dialogShow = false;
            }
          });
        } else {
          return false;
        }
      });
    },

    beforeClose() {
      this.ruleForm = Object.assign(this.ruleForm, this.$options.data().ruleForm);
      this.selectData = [];
      this.editDialog = false;
      this.dialogShow = false;
    },

    /* ------------ 其他 --------------*/
    // 保存
    saveData() {
      let params = { ...this.ruleForm };
      params.alarmId = this.alarmId;
      params.handleType = this.handleType;
      this.$http.post(mapAPI.addClues, params).then((res) => {
        if (res.status === 200) {
          this.ruleForm = Object.assign(this.ruleForm, this.$options.data().ruleForm);
          let msg = "";
          switch (params.handleType) {
            case "6":
              msg = "添加线索成功";
              break;
            case "7":
              msg = "上报成功";
              this.$router.push("/command/up-report");
              break;
            case "3":
              msg = "提交误报成功";
              this.$router.push("/command/finish");
              break;
            case "2":
              msg = "事件处理完成";
              this.$router.push("/command/finish");
              break;
          }
          this.$message.success(msg);
        }
      });
    },

    // 获取字典表（紧急程度）
    getCode() {
      this.$http
        .get(publicAPI.codeAndItem + "?codeValue=DEGREE_OF_EMERGENCY")
        .then((res) => {
          if (res.status === 200) {
            this.formConfig.items[0][0].data = res.result.DEGREE_OF_EMERGENCY;
          }
        });
    },

    // 切换菜单
    bntClick(id) {
      this.handleType = id;
      this.ruleForm = Object.assign(this.ruleForm, this.$options.data().ruleForm);

      if (id === "2" || id === "7") {
        this.formConfig.items[0][0].show = true;
      } else {
        this.formConfig.items[0][0].show = false;
      }

      if (id === "5") {
        this.getUserTask();
      }
    },
  },
};
</script>

<style lang="less">
@import "alarm-information";
.table_add {
	height: 50vh;
	display: flex;
	flex-direction: column;
  .el-table {
    margin: 10px 0 !important;
  }
}
</style>
